import type Sortable from "sortablejs";
import { createReorderable } from "../shared/sortable-reorder";

// cmsAreaCardsReorder backs the homepage areas section's area_cards widget
// drag handles. Mirrors cmsSectionRail (NOT cmsPropertyCards/cmsOtherProperties):
// each row is server-rendered templ embedding its OWN teaser/POI-picker/image-
// picker widgets with their own Alpine state (CMSWidgetAreaCards' AreaCardRows
// ride as Go values, not a JSON blob) — not an Alpine x-for — so this
// controller does NOT own an `items` array. It reads the live slug order
// straight from the DOM after every drag and emits the whole ordered array on
// cms-image-changed, to the FIXED site:homepage.areas target with field
// "order" (overlay {homepage:{areas:{order:[...]}}} via editor.ts's existing
// site:homepage.areas route — see service.CMSTargetSiteHomepageAreas's doc).
//
// Rows carry [data-area-card-row] [data-area-card-slug] and a
// [data-area-card-handle] drag grip; the container carries
// [data-area-card-list].
export function cmsAreaCardsReorder() {
  return {
    _sortable: null as Sortable | null,
    init() {
      const el = (this as any).$el as HTMLElement;
      const list = el.querySelector("[data-area-card-list]") as HTMLElement | null;
      if (!list) return;
      this._sortable = createReorderable(list, {
        handle: "[data-area-card-handle]",
        draggable: "[data-area-card-row]",
        onEnd: () => this._emit(),
      });
    },
    destroy() {
      this._sortable?.destroy();
      this._sortable = null;
    },
    // Read the current slug order from the DOM and emit it.
    _emit() {
      const el = (this as any).$el as HTMLElement;
      const list = el.querySelector("[data-area-card-list]") as HTMLElement | null;
      if (!list) return;
      const rows = Array.from(list.querySelectorAll<HTMLElement>("[data-area-card-row]"));
      const order = rows.map((r) => r.getAttribute("data-area-card-slug") || "").filter(Boolean);
      el.dispatchEvent(
        new CustomEvent("cms-image-changed", {
          detail: { field: "order", target: "site:homepage.areas", value: order },
          bubbles: true,
        }),
      );
    },
  };
}
